import Vue from "vue";
import Vuex from "vuex";
import borate from "@/store/borate";
import ch from "@/store/ch";
import customFieldStates from "@/store/customFieldStates";
import cya from "@/store/cya";
import effects from "@/store/effects";
import fc from "@/store/fc";
import fields from "@/store/fields";
import ph from "@/store/ph";
import settings from "@/store/settings";
import salt from "@/store/salt";
import ta from "@/store/ta";
import user from "@/store/user";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    borate,
    ch,
    customFieldStates,
    cya,
    effects,
    fc,
    fields,
    ph,
    settings,
    salt,
    ta,
    user,
  },
});
